import Reports from './ReportsPage';

export default Reports;
